/* eslint-disable react-hooks/exhaustive-deps */
import { notification } from 'antd'
import { ItemType, MenuItemType } from 'antd/es/menu/hooks/useItems'
import dayjs from 'dayjs'
import isoWeek from 'dayjs/plugin/isoWeek'
import { Clock9, Train } from 'lucide-react'
import { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'

import { useFilters, useGeneral } from '@contexts'
import { useToAuthorize } from '@hooks'
import { PATHS, WebTitleEnum } from '@types'

import { StyledMenu } from '../../../components/StyledComponents'

dayjs.extend(isoWeek)

const AdminMenu: () => JSX.Element = () => {
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { resetFilters } = useFilters()
  const { data, isLoading } = useToAuthorize()
  const { setTicketToSearch } = useGeneral()
  const [notified, setNotified] = useState(false)
  const [requests, setRequests] = useState(0)

  useEffect(() => {
    document.title = `${!data ? WebTitleEnum.TITLE : `${`(${data})`} ${WebTitleEnum.TITLE}`}`
  }, [data])

  useEffect(() => {
    if (!notified) {
      if (data) {
        notification.info({
          message:
            // eslint-disable-next-line no-nested-ternary
            data > 0
              ? data === 1
                ? `${t('notifications.preffix')} una ${t(
                    'globals.generics.to_authorize_request',
                  ).toLowerCase()}`
                : `${t('notifications.preffix')} ${data} ${t(
                    'globals.generics.to_authorize_requests',
                  ).toLowerCase()}`
              : `${t('preffix_not')} ${t('globals.generics.to_authorize_requests').toLowerCase()}`,
          duration: 3,
        })
        setNotified(true)
        setRequests(data)
      }
    } else {
      // eslint-disable-next-line no-lonely-if
      if (data && data > requests && data - requests > 1) {
        notification.info({
          message: `Tiene ${data} solicitudes para autorizar`,
          duration: 3,
        })
        setRequests(data)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  const clearFiltersOnComponentChange = () => {
    setTicketToSearch(undefined)
    resetFilters()
  }

  const handleClickBlocktrains = () => {
    navigate(PATHS.ADMIN.BLOCKTRAINS)
    clearFiltersOnComponentChange()
  }
  const handleClickHistoric = () => {
    navigate(PATHS.ADMIN.HISTORIC)
    clearFiltersOnComponentChange()
  }
  // const onSettingsClick = () => {
  //   navigate(PATHS.ADMIN.SETTINGS)
  //   clearFiltersOnComponentChange()
  // }

  const items: ItemType<MenuItemType>[] = useMemo(
    () => [
      {
        key: PATHS.ADMIN.BLOCKTRAINS,
        onClick: handleClickBlocktrains,
        icon: <Train style={{ fontSize: '18px' }} />,
        label: (
          <>
            {t('blocktrains')}
            {/* //TODO: Pendiente de implementación la notificación de solicitudes para autorizar */}
            {/* {isLoading ? (
              <LoadingOutlined />
            ) : data && data > 0 ? (
              <Badge className="menu-badge" count={data}>
                <NotificationOutlined style={{ cursor: 'pointer' }} />
              </Badge>
            ) : (
              ''
            )} */}
          </>
        ),
      },
      {
        key: PATHS.ADMIN.HISTORIC,
        onClick: handleClickHistoric,
        icon: <Clock9 />,
        label: t('historic'),
      },
    ],
    [data, isLoading, pathname, t], //onSettingsClick, TODO: pendiente de implementación//
  )

  return <StyledMenu selectedKeys={[pathname]} mode="inline" items={items} />
}

export { AdminMenu }
